import { render, staticRenderFns } from "./BBButton.vue?vue&type=template&id=43a06708&scoped=true"
import script from "./BBButton.vue?vue&type=script&lang=ts"
export * from "./BBButton.vue?vue&type=script&lang=ts"
import style0 from "./BBButton.vue?vue&type=style&index=0&id=43a06708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a06708",
  null
  
)

export default component.exports